import axios from "axios-base";
import { toastControl } from "./toastControl";
import { errorRender } from "./check";

export const updateUser = async (user, data) => {
  if (user) {
    const update = await axios.put(`/members/${user._id}`, data);
    return { update };
  }
};

export const sendContact = async (values) => {
  try {
    const result = await axios.post("/contacts", values);
    toastControl("success", "Таны саналыг хүлээж авлаа");
    return result;
  } catch (error) {
    toastControl("error", "Алдаа гарлаа дахин оролдоно уу");
  }
};

export const saveBooking = async (values, options = {}) => {
  try {
    const result = await axios.post("/tourbookings", values);
    toastControl("success", options.successMessage || "Захиалга хүлээн авлаа");
    return result;
  } catch (error) {
    const rendered = errorRender(error);
    const defaultMessage = "Алдаа гарлаа дахин оролдоно уу";
    const finalMessage =
      options.errorMessage && rendered === defaultMessage
        ? options.errorMessage
        : rendered;
    toastControl("error", finalMessage);
    return;
  }
};

export const saveRent = async (values, options = {}) => {
  try {
    const result = await axios.post("/rentorders", values);
    toastControl("success", options.successMessage || "Захиалга хүлээн авлаа");
    return result;
  } catch (error) {
    console.log(error);
    const rendered = errorRender(error);
    const defaultMessage = "Алдаа гарлаа дахин оролдоно уу";
    const finalMessage =
      options.errorMessage && rendered === defaultMessage
        ? options.errorMessage
        : rendered;
    toastControl("error", finalMessage);
  }
};

export const sendEmail = async (values) => {
  try {
    const result = await axios.post("/email-lists", values);
    toastControl("success", "Таны мэйл илгээгдлээ");
    return result;
  } catch (error) {
    toastControl("error", "Алдаа гарлаа дахин оролдоно уу");
  }
};

export const updateExperience = async (user, data) => {
  if (user) {
    try {
      return { experience: result.data.data };
    } catch (error) {
      console.log(error);
    }
  }
};

export const createTreeOrder = async (data) => {
  try {
    const result = await axios.post("/tree-orders", data);
    return { result };
  } catch (error) {
    return { error };
  }
};

export const createContact = async (data) => {
  try {
    const result = await axios.post("/contacts", data);
    return { result };
  } catch (error) {
    return { error };
  }
};

export const createUser = async (user, data) => {
  if (user) {
    const result = await axios.put(`/members/${user._id}`, data);
    return { result };
  }
};

export const changePassword = async (user, data) => {
  if (user) {
    const result = await axios.put(`/members/memberpasswordchange`, data);
    return { result };
  }
};
